const COLOR_MAP: Record<string, string> = {
  // Basic colors
  black: '#1a1a1a',
  white: '#FFFFFF',
  // Skin tones / Neutrals
  nude: '#E8C4A5',
  'nude beige': '#E8C4A5',
  beige: '#D4B896',
  'light beige': '#F5E6D3',
  tan: '#D2B48C',
  'rose tan': '#C9A69A',
  sand: '#C2B280',
  chai: '#B5651D',
  latte: '#C8A27A',
  oatmeal: '#D9CBBF',
  // Browns
  chocolate: '#7B3F00',
  brown: '#8B4513',
  'dark brown': '#5C4033',
  mocha: '#967969',
  coffee: '#6F4E37',
  caramel: '#C68E17',
  espresso: '#3C2415',
  cocoa: '#D2691E',
  // Grays
  gray: '#808080',
  grey: '#808080',
  charcoal: '#36454F',
  'dark gray': '#4a4a4a',
  'light gray': '#D3D3D3',
  // Blues
  navy: '#1E3A8A',
  blue: '#3B82F6',
  // Reds/Pinks
  red: '#DC2626',
  pink: '#EC4899',
  rose: '#F43F5E',
  burgundy: '#722F37',
  // Greens
  green: '#22C55E',
  olive: '#808000',
  // Other
  purple: '#9333EA',
  orange: '#F97316',
  yellow: '#EAB308',
  coral: '#FF7F50',
  cream: '#FFFDD0',
  ivory: '#FFFFF0',
};

export function getColorCode(colorName: string): string {
  return COLOR_MAP[colorName.toLowerCase().trim()] || '#CCCCCC';
}
